(function () {
    'use strict';

    angular.module("imApp").factory("docPacksBAddService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 3298,
                    parameters: parms || {}
                });
            },
            addItems: function (mergeObj) {
                return $ihttp.post({
                    method: 3300,
                    parameters: mergeObj
                });
            }
        };

        return service;
    }]);
})();
